"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GACHA_CARD_WIDTH = void 0;
exports.GachaCard = GachaCard;
exports.GachaCardSkeleton = GachaCardSkeleton;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var theme_1 = require("../../theme");
var GlassCard_1 = require("../GlassCard");
var LockBadge_1 = require("../LockBadge");
var OnSiteOnlyBadge_1 = require("../OnSiteOnlyBadge");
/** カード幅 (px)。GachaCard / GachaCardSkeleton で共通の既定値として使う */
exports.GACHA_CARD_WIDTH = 335;
// 画像の幅・高さ (Figma仕様の160×119)。GachaCard本体とSkeletonで
// 寸法がズレないよう共通の定数にする
var GACHA_IMAGE_WIDTH = 160;
var GACHA_IMAGE_HEIGHT = 119;
// fullWidth時の画像列比率 (Figma仕様の40.6%)。GachaCard本体とSkeletonで
// 寸法がズレないよう共通の定数にする
var GACHA_FULL_WIDTH_IMAGE_RATIO = '40.6%';
/** fullWidthに応じたカード全体の幅。GachaCard/GachaCardSkeletonで共通利用する */
function getGachaCardWidth(fullWidth) {
    return fullWidth ? '100%' : exports.GACHA_CARD_WIDTH;
}
/** fullWidthに応じた画像列/テキスト列のgridTemplateColumns。GachaCard/GachaCardSkeletonで共通利用する */
function getGachaGridTemplateColumns(fullWidth) {
    return fullWidth
        ? "".concat(GACHA_FULL_WIDTH_IMAGE_RATIO, " 1fr")
        : "".concat(GACHA_IMAGE_WIDTH, "px 1fr");
}
function GachaCard(_a) {
    var imageUrl = _a.imageUrl, title = _a.title, endAtLabel = _a.endAtLabel, endAtLabelColor = _a.endAtLabelColor, _b = _a.endAtLabelFontWeight, endAtLabelFontWeight = _b === void 0 ? 400 : _b, isOnSiteOnly = _a.isOnSiteOnly, _c = _a.onSiteOnlyLabel, onSiteOnlyLabel = _c === void 0 ? '現地限定' : _c, isPremium = _a.isPremium, href = _a.href, fullWidth = _a.fullWidth, sx = _a.sx;
    var p = (0, theme_1.useV2Palette)();
    return ((0, jsx_runtime_1.jsx)(GlassCard_1.GlassCard, { bordered: false, cornerRadius: 8, highlight: true, sx: __spreadArray([
            { width: getGachaCardWidth(fullWidth) }
        ], (Array.isArray(sx) ? sx : [sx]), true), children: (0, jsx_runtime_1.jsx)(material_1.CardActionArea, { href: href !== null && href !== void 0 ? href : '', sx: { position: 'relative' }, children: (0, jsx_runtime_1.jsxs)(material_1.Box, { sx: {
                    display: 'grid',
                    gridTemplateColumns: getGachaGridTemplateColumns(fullWidth),
                    gap: 2,
                }, children: [(0, jsx_runtime_1.jsx)(material_1.Box, { sx: { position: 'relative', height: "".concat(GACHA_IMAGE_HEIGHT, "px") }, children: (0, jsx_runtime_1.jsx)(material_1.Box, { component: "img", alt: title, src: imageUrl, sx: {
                                position: 'absolute',
                                inset: 0,
                                width: 1,
                                height: 1,
                                objectFit: 'cover',
                            } }) }), (0, jsx_runtime_1.jsxs)(material_1.Stack, { spacing: 2, justifyContent: "center", sx: { pr: '8px' }, children: [(isOnSiteOnly || isPremium) && ((0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", justifyContent: "space-between", alignItems: "center", children: [isOnSiteOnly ? ((0, jsx_runtime_1.jsx)(OnSiteOnlyBadge_1.OnSiteOnlyBadge, { label: onSiteOnlyLabel })) : ((0, jsx_runtime_1.jsx)(material_1.Box, {})), isPremium && (0, jsx_runtime_1.jsx)(LockBadge_1.LockBadge, {})] })), (0, jsx_runtime_1.jsxs)(material_1.Stack, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { sx: {
                                            fontSize: 14,
                                            lineHeight: '20px',
                                            fontWeight: 600,
                                            letterSpacing: '-0.05px',
                                            color: 'text.primary',
                                            display: '-webkit-box',
                                            WebkitBoxOrient: 'vertical',
                                            WebkitLineClamp: 2,
                                            overflow: 'hidden',
                                            overflowWrap: 'anywhere',
                                        }, children: title }), endAtLabel && ((0, jsx_runtime_1.jsx)(material_1.Typography, { sx: {
                                            fontSize: 12,
                                            lineHeight: '16px',
                                            fontWeight: endAtLabelFontWeight,
                                            color: endAtLabelColor !== null && endAtLabelColor !== void 0 ? endAtLabelColor : p.foreground.neutral.secondary,
                                        }, children: endAtLabel }))] })] })] }) }) }));
}
function GachaCardSkeleton(_a) {
    var fullWidth = _a.fullWidth;
    return ((0, jsx_runtime_1.jsx)(GlassCard_1.GlassCard, { bordered: false, cornerRadius: 8, highlight: true, sx: { width: getGachaCardWidth(fullWidth) }, children: (0, jsx_runtime_1.jsxs)(material_1.Box, { sx: {
                display: 'grid',
                gridTemplateColumns: getGachaGridTemplateColumns(fullWidth),
                gap: 2,
            }, children: [(0, jsx_runtime_1.jsx)(material_1.Skeleton, { variant: "rectangular", sx: { height: "".concat(GACHA_IMAGE_HEIGHT, "px") } }), (0, jsx_runtime_1.jsxs)(material_1.Stack, { spacing: 2, justifyContent: "center", sx: { pr: '8px' }, children: [(0, jsx_runtime_1.jsx)(material_1.Skeleton, { variant: "text", width: "100%" }), (0, jsx_runtime_1.jsx)(material_1.Skeleton, { variant: "text", width: "60%" })] })] }) }));
}
